import { FLOW_TYPES } from './oaBusiness'
const DETAIL_PATHS = {
  contractPlanFund: '/crm/plan-fund/detail/',
  contractFundRecord: '/crm/fund-record/detail/',
  contractInvoice: '/crm/invoice/detail/',
  serviceOrder: '/crm/serviceOrder/detail/',
  deliveryOrder: '/crm/deliveryOrder/detail/'
}

function hasValue(value) {
  return value !== undefined && value !== null && value !== ''
}

// An approval without a registered business page is still accessible by work-order ID.
// Never fabricate a business route for a future or incomplete approval record.
export function approvalSourceLocation(row) {
  if (!row || !/^\d+$/.test(String(row.targetId)) || Number(row.targetId) <= 0) return null
  const targets = ['contract', 'business', 'clue', 'quote', 'purchaseApply', 'procurement', 'purchase_apply',
    'purchaseContractApproval', 'expenseClaim', 'paymentApplication', 'loanApplication', 'invoiceApplication', 'assetRepair']
  if (!(targets.includes(row.targetType) || Object.keys(FLOW_TYPES).some(type => FLOW_TYPES[type].target === row.targetType))) return null
  return messageSourceLocation({ ...row, id: null })
}

export function messageSourceLocation(message) {
  const item = message || {}
  const targetType = item.targetType || ''
  const targetId = hasValue(item.targetId) ? item.targetId : item.sourceId
  const query = hasValue(item.id) ? { interactionMessageId: item.id } : {}

  if ((item.sourceType || '').startsWith('workLog')) {
    return { path: '/crm/work-log', query }
  }
  if (!targetType || !hasValue(targetId)) {
    return null
  }
  const businessType = Object.keys(FLOW_TYPES).find(type=>FLOW_TYPES[type].target===targetType)
  if(businessType)return {path:`/oa/business/${businessType}/detail/${targetId}`,query}
  if (targetType === 'purchaseContractApproval') return { path: `/procurement/contracts/detail/${targetId}`, query }
  if (['purchaseApply', 'procurement', 'purchase_apply'].includes(targetType)) {
    return { path: `/procurement/apply/detail/${targetId}`, query }
  }
  const financeType = { paymentApplication: 'PAYMENT', loanApplication: 'LOAN', invoiceApplication: 'INVOICE' }[targetType]
  if (financeType) return { path: `/finance/applications/${financeType}/detail/${targetId}`, query }
  if (targetType === 'expenseClaim') return { path: `/finance/expense/detail/${targetId}`, query: (item.sourceType || '').startsWith('expense') ? {} : query }
  if (targetType === 'assetRepair') {
    if (hasValue(item.workOrderId)) query.workOrderId = item.workOrderId
    return { path: `/assetManagement/assetRepairApproval/${targetId}`, query }
  }
  if (targetType === 'quote') {
    query.quoteId = targetId
    return { path: '/crm/quote', query }
  }
  if (DETAIL_PATHS[targetType]) {
    return { path: DETAIL_PATHS[targetType] + targetId, query }
  }
  return { path: `/crm/${targetType}/detail/${targetId}`, query }
}
